import { get } from '@/lib/api/client'
import type { AnnouncementHighlight, ApiResponse } from '@/lib/api/types'

export class AnnouncementService {
  /**
   * Get highlighted announcements (public endpoint)
   * GET /announcements/public/highlighted
   */
  async getHighlightedAnnouncements(): Promise<ApiResponse<AnnouncementHighlight>> {
    return await get<ApiResponse<AnnouncementHighlight>>('announcements/public/highlighted')
  }
}

export const announcementService = new AnnouncementService()

export default announcementService
